export default {
  SET_CURRENT_GENERATION_MESSAGE: 'setCurrentGenerationMessage',
  ADD_QUEUE_ITEM: 'addQueueItem',
  UPDATE_QUEUE_ITEM: 'updateQueueItem',
  REMOVE_QUEUE_ITEM: 'removeQueueItem',
  SET_GENERATING_SYNTHETIC: 'setGeneratingSynthetic',
  SET_GENERATING_UPSCALE: 'setGeneratingUpscale',
  SET_REMAINING_BALANCE: 'setRemainingBalance'
}
